/** @format */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './style';
import Skeleton from '@mui/material/Skeleton';
import { Icons } from 'components';


const BizStatus = ({ statusBiz }) => {
  const classes = useStyles();

  if (statusBiz === null) {
    return <Skeleton variant="text" width={90} height={37} />;
  }

  if (statusBiz === 'accepted') {
    return (
      <Box display="flex">
        <span className={classes.success} >
          <Icons icon="Accept" color="#43A047" size="18" />
        </span>
        <Typography>
          <b>تایید شده</b>
        </Typography>
      </Box>
    );
  }

  if (statusBiz === 'pending') {
    return (
      <Box display="flex">
       
        <span className={classes.info} >
          <Icons icon="Info" color="#667585" size="18" />
        </span>
        <Typography>
          <b>در حال بررسی</b>
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex">
     
      <span className={classes.error} >
        <Icons icon="CloseCircle" color="#343434" size="18" />
      </span>
      <Typography style={{ color: 'red' }}>
        <b>تایید نشده</b>
      </Typography>
    </Box>
  );
};

export default BizStatus;
